import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitAitAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitAitAssessmentResultInput;
}>;


export type SubmitAitAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitAitAssessmentResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitAitAssessmentResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & AitAssessmentResultFragment
    )> }
  ) }
);

export type AitAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: (
    { __typename: 'AitResult' }
    & AitAssessmentResultDataFragment
  ) | { __typename: 'CardioRespResult' } | { __typename: 'DigitSpanResult' } | { __typename: 'GrowthMindsetResult' } | { __typename: 'InbodyCompositionResult' } | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'NBackResult' } | { __typename: 'OrganisationalAiReadinessResult' } | { __typename: 'PersonalCopingResult' } | { __typename: 'ProcessingSpeedResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } }
);

export type AitAssessmentResultDataFragment = (
  { __typename: 'AitResult' }
  & Pick<SchemaTypes.AitResult, 'normalisedAccuracy' | 'normalisedFlexibility' | 'normalisedSpeed' | 'compositeScore' | 'totalTrials' | 'correctTrials' | 'totalErrors' | 'perseverativeErrors'>
  & { trials: Array<(
    { __typename: 'AitTrialResult' }
    & Pick<SchemaTypes.AitTrialResult, 'trialNumber' | 'isCorrect' | 'isPerseverative' | 'reactionTimeMs' | 'ruleShiftOccurred'>
  )>, levelDetail: (
    { __typename: 'AitLevelConfig' }
    & Pick<SchemaTypes.AitLevelConfig, 'level' | 'label' | 'description'>
  ), confidenceBand: (
    { __typename: 'AitConfidenceBand' }
    & Pick<SchemaTypes.AitConfidenceBand, 'label' | 'margin'>
  ), diagnosticMetrics: (
    { __typename: 'AitDiagnosticMetrics' }
    & Pick<SchemaTypes.AitDiagnosticMetrics, 'perseverationRate' | 'switchingCost' | 'learningRate' | 'errorRecovery' | 'medianRt' | 'mixingCost' | 'categoriesCompleted' | 'failureToMaintain' | 'ruleDiscovery'>
  ) }
);

export const AitAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AitAssessmentResultData on AitResult {
  trials {
    trialNumber
    isCorrect
    isPerseverative
    reactionTimeMs
    ruleShiftOccurred
  }
  normalisedAccuracy
  normalisedFlexibility
  normalisedSpeed
  compositeScore
  levelDetail {
    level
    label
    description
  }
  totalTrials
  correctTrials
  totalErrors
  perseverativeErrors
  confidenceBand {
    label
    margin
  }
  diagnosticMetrics {
    perseverationRate
    switchingCost
    learningRate
    errorRecovery
    medianRt
    mixingCost
    categoriesCompleted
    failureToMaintain
    ruleDiscovery
  }
}
    `;
export const AitAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment AitAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on AitResult {
      ...AitAssessmentResultData
    }
  }
  createdAt
}
    ${AitAssessmentResultDataFragmentDoc}`;
export const SubmitAitAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation SubmitAitAssessmentResult($input: SubmitAitAssessmentResultInput!) {
  submitAitAssessmentResult(input: $input) {
    ... on SubmitAitAssessmentResultSuccessfulResponse {
      result {
        ...AitAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${AitAssessmentResultFragmentDoc}`;
export type SubmitAitAssessmentResultMutationFn = Apollo.MutationFunction<SubmitAitAssessmentResultMutation, SubmitAitAssessmentResultMutationVariables>;

/**
 * __useSubmitAitAssessmentResultMutation__
 *
 * To run a mutation, you first call `useSubmitAitAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAitAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAitAssessmentResultMutation, { data, loading, error }] = useSubmitAitAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitAitAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAitAssessmentResultMutation, SubmitAitAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAitAssessmentResultMutation, SubmitAitAssessmentResultMutationVariables>(SubmitAitAssessmentResultDocument, options);
      }
export type SubmitAitAssessmentResultMutationHookResult = ReturnType<typeof useSubmitAitAssessmentResultMutation>;
export type SubmitAitAssessmentResultMutationResult = Apollo.MutationResult<SubmitAitAssessmentResultMutation>;
export type SubmitAitAssessmentResultMutationOptions = Apollo.BaseMutationOptions<SubmitAitAssessmentResultMutation, SubmitAitAssessmentResultMutationVariables>;